(function(){
  'use strict';

  var STORAGE_CLAIM='pawling_select_claim_v5';
  var STORAGE_REF='pawling_referral_v3';
  var CLAIM_TTL=90*24*60*60*1000;
  var REF_TTL=90*24*60*60*1000;
  var VALID_INVITES={
    'f1cb745a666f0e26b14662c8b9663e3f15a66ba5370881b96479cba9cf05358d':{id:'PS-002',business:'701 Global Bullies',contact:'Larry Joe'},
    '1b960e32a686f93c6361b2ffa33a5a0f358fbd905fb8afba9138a60d3e87e982':{id:'PS-001',business:'Bird City Mini Bullies',contact:'Trapmoney Pheno'}
  };

  function normalize(value){return String(value||'').toUpperCase().replace(/[^A-Z0-9]/g,'').slice(0,40);}
  function safeJSON(value){try{return JSON.parse(value);}catch(e){return null;}}
  function getStored(key,ttl){
    try{
      var data=safeJSON(localStorage.getItem(key));
      if(!data||!data.savedAt||Date.now()-data.savedAt>ttl){localStorage.removeItem(key);return null;}
      return data;
    }catch(e){return null;}
  }
  function saveStored(key,data){try{localStorage.setItem(key,JSON.stringify(Object.assign({},data,{savedAt:Date.now()})));}catch(e){}}
  function hex(buffer){return Array.prototype.map.call(new Uint8Array(buffer),function(b){return b.toString(16).padStart(2,'0');}).join('');}
  function digest(code){
    if(!window.crypto||!window.crypto.subtle||!window.TextEncoder)return Promise.resolve('');
    return window.crypto.subtle.digest('SHA-256',new TextEncoder().encode(code)).then(hex).catch(function(){return '';});
  }
  function validate(code){
    code=normalize(code);
    if(!code)return Promise.resolve(null);
    return digest(code).then(function(hash){
      var invite=VALID_INVITES[hash];
      return invite?Object.assign({code:code},invite):null;
    });
  }
  function publicReferral(code){
    code=normalize(code);
    if(code.length<4)return null;
    return {code:code,business:'Pawling Partner',source:'Public Pawling referral link'};
  }
  function hidden(form,name,value){
    if(!form)return;
    var selector='input[type="hidden"][data-pawling-field="'+name.replace(/"/g,'')+'"]';
    var input=form.querySelector(selector);
    if(!input){input=document.createElement('input');input.type='hidden';input.dataset.pawlingField=name;input.name='contact['+name+']';form.appendChild(input);}
    input.value=value;
  }
  function addReferralToForms(ref){
    if(!ref||!ref.code)return;
    ['PawlingPuppyInquiry','PawlingBusinessSubmission','PawlingPartnerApplication'].forEach(function(id){
      var form=document.getElementById(id);if(!form)return;
      hidden(form,'Pawling referral code',ref.code);
      hidden(form,'Pawling referral business',ref.business||'Private Pawling invite');
      hidden(form,'Pawling referral first seen',new Date(ref.firstSeen||ref.savedAt||Date.now()).toISOString());
    });
  }
  function updateCartReferral(ref){
    if(!ref||!ref.code||!window.fetch)return;
    var body={attributes:{'Pawling referral code':ref.code,'Pawling referral business':ref.business||'Private Pawling invite','Pawling referral first seen':new Date(ref.firstSeen||Date.now()).toISOString()}};
    fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).catch(function(){});
  }
  function text(id,value){var el=document.getElementById(id);if(el)el.textContent=value;}
  function populateClaimUI(claim){
    if(!claim)return;
    text('PawlingSelectBusinessName',claim.business||'your business');
    text('PawlingSelectTitle',(claim.business||'Your business')+', your free ad form is ready.');
    text('PawlingSelectReturnTitle',(claim.business||'Pawling')+' upload link recognized');
  }
  function closeModal(){
    var shell=document.getElementById('PawlingSelectShell');
    if(shell){shell.hidden=true;document.body.classList.remove('pawling-select-modal-open');}
  }
  function showModal(claim){
    populateClaimUI(claim);
    var shell=document.getElementById('PawlingSelectShell');
    if(!shell)return;
    shell.hidden=false;document.body.classList.add('pawling-select-modal-open');
    var modal=shell.querySelector('.pawling-select-modal');if(modal)setTimeout(function(){modal.focus();},30);
  }
  function activateSellerForm(){
    window.location.assign('https://form.jotform.com/262830831243049');
  }
  function showReturn(claim){
    populateClaimUI(claim);
    var bar=document.getElementById('PawlingSelectReturn');if(!bar||!claim)return;
    bar.hidden=false;
    var btn=document.getElementById('PawlingSelectReturnButton');if(btn)btn.onclick=function(){activateSellerForm(claim);};
  }
  function bind(claim){
    document.querySelectorAll('[data-pawling-select-close]').forEach(function(el){if(el.dataset.pawlingBound)return;el.addEventListener('click',closeModal);el.dataset.pawlingBound='true';});
    var open=document.getElementById('PawlingSelectOpenForm');if(open&&!open.dataset.pawlingBound){open.addEventListener('click',function(){activateSellerForm(claim);});open.dataset.pawlingBound='true';}
    if(!document.documentElement.dataset.pawlingSelectEscape){document.addEventListener('keydown',function(e){if(e.key==='Escape')closeModal();});document.documentElement.dataset.pawlingSelectEscape='true';}
  }
  function init(){
    var params;try{params=new URLSearchParams(window.location.search||'');}catch(e){params=new URLSearchParams();}
    var claimParam=normalize(params.get('claim'));
    var refParam=normalize(params.get('ref'));
    var storedClaim=getStored(STORAGE_CLAIM,CLAIM_TTL);
    var storedRef=getStored(STORAGE_REF,REF_TTL);

    Promise.all([validate(claimParam),validate(refParam)]).then(function(results){
      var claim=results[0];var ref=results[1]||publicReferral(refParam);
      if(claim){claim.firstSeen=Date.now();saveStored(STORAGE_CLAIM,claim);storedClaim=claim;}
      if(ref){ref.firstSeen=Date.now();saveStored(STORAGE_REF,ref);storedRef=ref;}
      if(storedRef){addReferralToForms(storedRef);updateCartReferral(storedRef);}
      if(storedClaim){populateClaimUI(storedClaim);bind(storedClaim);if(claim)showModal(storedClaim);else showReturn(storedClaim);}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',function(){
    var claim=getStored(STORAGE_CLAIM,CLAIM_TTL);var ref=getStored(STORAGE_REF,REF_TTL);
    if(claim){populateClaimUI(claim);bind(claim);}if(ref)addReferralToForms(ref);
  });
})();
